import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Siteregisterform from '../Sitemanagementcomponents/Siteregisterform';
import FullScreenModal from '../Sitemanagementcomponents/FullScreenModal';
import SiteBoundaryMapModal from '../Sitemanagementcomponents/SiteBoundaryMapModal';
import SiteTable from '../Sitemanagementcomponents/SiteTable';
import { Button } from '../../UI/Buttons';
import { Title } from '../../UI/Typography';
import { getAllSites } from '../../../Services/Api/siteService';

const PageContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.lg};
  background-color: ${({ theme }) => theme.colors.background};
  max-height: 100vh;
`;

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

const DrawButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.text.inverse};
  
  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.secondary};
  }
`;

function Siteregistration() {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isMapModalOpen, setIsMapModalOpen] = useState(false);
  const [sites, setSites] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedSite, setSelectedSite] = useState(null);

  useEffect(() => {
    const fetchSites = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const fetchedSites = await getAllSites();
        setSites(fetchedSites);
      } catch (err) {
        setError(err.message || 'Failed to load sites.');
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchSites();
  }, []);

  const openAddModal = () => setIsAddModalOpen(true);
  const closeAddModal = () => setIsAddModalOpen(false);

  const handleViewBoundaryClick = (site) => {
    setSelectedSite(site);
    setIsMapModalOpen(true);
  };

  const closeMapModal = () => {
    setIsMapModalOpen(false);
    setSelectedSite(null);
  };

  const refreshSites = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const fetchedSites = await getAllSites();
      setSites(fetchedSites);
    } catch (err) {
      setError(err.message || 'Failed to reload sites.');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PageContainer>
      <TitleContainer>
        <Title>Site Management</Title>
        <DrawButton onClick={openAddModal}>Add New Site</DrawButton>
      </TitleContainer>

      <SiteTable
        sites={sites}
        isLoading={isLoading}
        error={error}
        onViewBoundary={handleViewBoundaryClick}
        onRefresh={refreshSites}
      />

      <FullScreenModal isOpen={isAddModalOpen} onClose={closeAddModal}>
        <Siteregisterform onSuccessfulSubmit={() => { refreshSites(); closeAddModal(); }} />
      </FullScreenModal>

      <SiteBoundaryMapModal
        isOpen={isMapModalOpen}
        onClose={closeMapModal}
        siteName={selectedSite?.name}
        boundaryWkt={selectedSite?.boundary}
      />
    </PageContainer>
  );
}

export default Siteregistration;
